export default __webpack_public_path__ + "static/media/close.3721b02e.svg";